export default __webpack_public_path__ + "images/LH.1d56a4c.png";